import { motion } from "framer-motion"
import BaseInputField from "./BaseInputField"
import { useState } from "react"
import {
    defaultBillCategorie,
    defaultBillType,
    defaultOfferStatusValues,
    defaultPayreqStatusValues,
    defaultPositions,
} from "../../data/defaultValues"
import { ReactComponent as CLOSE } from "../../assets/CloseICON.svg"
import BaseSectionHeadline from "./BaseSectionHeadline"

type FilterModalType = {
    removeFilter: () => void
    visible: boolean
    setVisible: () => void
    statusType: "offer" | "payreq" | "bill" | "object" | "employee" | "customer" | "absence" | "major-order" | "credit"
    searchArchived?: boolean | undefined
    changeArchived?: (e: boolean | undefined) => void
    searchDeleted?: boolean | undefined
    changeDeleted?: (e: boolean) => void
    searchStatus?: string
    changeStatus?: (c: string) => void
    searchdateSince?: string
    changeDateSince?: (e: string) => void
    searchdateTo?: string
    changeDateTo?: (e: string) => void
    searchbillType?: string
    changebillType?: (e: string) => void
    searchPosition?: string | undefined
    changePosition?: (e: string | undefined) => void
    searchbillCategorie?: string
    changebillCategorie?: (e: string) => void
    searchCanceled?: boolean | undefined
    changeCanceled?: (e: boolean | undefined) => void
    searchCredit?: boolean | undefined
    changeCredit?: (e: boolean | undefined) => void
    height?: string
    sessionStorageKey?: string // TODO required
}

export default function BaseFilterModal(props: FilterModalType) {
    const [billType, setbillType] = useState(props.searchbillType ?? "")
    const [credit, setcredit] = useState(props.searchCredit ?? undefined)
    const [billCategorie, setbillCategorie] = useState(props.searchbillCategorie ?? "")
    const [archived, setarchived] = useState(props.searchArchived ?? undefined)
    const [deleted, setdeleted] = useState(props.searchDeleted ?? false)
    const [canceled, setcanceled] = useState(props.searchCanceled ?? undefined)
    const [status, setstatus] = useState(props.searchStatus ?? "")
    const [position, setposition] = useState(props.searchPosition ?? undefined)
    const [dateSince, setdateSince] = useState(props.searchdateSince ?? "")
    const [dateTo, setdateTo] = useState(props.searchdateTo ?? "")

    const useFilter = () => {
        if (props.changeStatus) {
            props.changeStatus(status)
            sessionStorage.setItem(props.sessionStorageKey + "status", JSON.stringify(status))
        }
        if (props.changeArchived) {
            props.changeArchived(archived)
            sessionStorage.setItem(props.sessionStorageKey + "archived", JSON.stringify(archived))
        }
        if (props.changeDeleted) {
            props.changeDeleted(deleted)
            sessionStorage.setItem(props.sessionStorageKey + "deleted", JSON.stringify(deleted))
        }
        if (props.changeCanceled) {
            props.changeCanceled(canceled)
            sessionStorage.setItem(props.sessionStorageKey + "canceled", JSON.stringify(canceled))
        }
        if (props.changeDateSince && dateSince !== "") {
            props.changeDateSince(dateSince)
            sessionStorage.setItem(props.sessionStorageKey + "dateSince", JSON.stringify(dateSince))
        }
        if (props.changeDateTo && dateTo !== "") {
            props.changeDateTo(dateTo)
            sessionStorage.setItem(props.sessionStorageKey + "dateTo", JSON.stringify(dateTo))
        }
        if (props.changebillType) {
            props.changebillType(billType)
            sessionStorage.setItem(props.sessionStorageKey + "billType", JSON.stringify(billType))
        }
        if (props.changePosition) {
            props.changePosition(position)
            sessionStorage.setItem(props.sessionStorageKey + "position", JSON.stringify(position))
        }
        if (props.changebillCategorie) {
            props.changebillCategorie(billCategorie)
            sessionStorage.setItem(props.sessionStorageKey + "billCategorie", JSON.stringify(billCategorie))
        }
        if (props.changeCredit) {
            props.changeCredit(credit)
            sessionStorage.setItem(props.sessionStorageKey + "credit", JSON.stringify(credit))
        }
        props.setVisible()
    }

    const removeInternFilterValues = () => {
        setarchived(undefined)
        setcanceled(undefined)
        setstatus("")
        setdateSince("")
        setdateTo("")
        setbillType("")
        setbillCategorie("")
        setposition("")
        setcredit(undefined)
        setdeleted(false)
    }

    return (
        <motion.div
            initial={{
                x: "150%",
                y: "",
                opacity: "",
            }}
            animate={{
                x: props.visible ? 0 : "150%",
                y: 0,
                opacity: 1,
            }}
            transition={{
                type: "ease",
                duration: 0.3,
            }}
            className={`absolute top-0  sm:rounded-default sm:top-32 lg:top-20 right-0 sm:right-4 pt-8 w-full sm:w-96 flex flex-col shadow-lg bg-white px-4 pb-4 z-50 overflow-y-scroll text-sm ${
                props.height ?? "h-full sm:max-h-[80%] sm:h-fit"
            }`}>
            <CLOSE className="w-6 h-6 absolute top-4 right-4 cursor-pointer" onClick={props.setVisible} />
            <BaseSectionHeadline label={"Filter"} classProps="!mb-0" />
            {/* Filter Bill Categories */}
            {props.changebillCategorie && (
                <div className="flex flex-col gap-1 pt-4">
                    <h3 className="py-1 font-medium">Nach Kategorie filtern</h3>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-billCategorie"
                            className="radio"
                            value="option1"
                            checked={
                                billCategorie === defaultBillCategorie.HAUSMEISTER || props.searchbillCategorie === defaultBillCategorie.HAUSMEISTER
                            }
                            onChange={() => setbillCategorie(defaultBillCategorie.HAUSMEISTER)}
                        />
                        <p>Hausmeister</p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-billCategorie"
                            className="radio"
                            value="option2"
                            checked={
                                billCategorie === defaultBillCategorie.SCHLUESSELDIENST ||
                                props.searchbillCategorie === defaultBillCategorie.SCHLUESSELDIENST
                            }
                            onChange={() => setbillCategorie(defaultBillCategorie.SCHLUESSELDIENST)}
                        />
                        <p>Schlüsseldienst</p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-billCategorie"
                            className="radio"
                            value="option3"
                            checked={billCategorie === defaultBillCategorie.BAU || props.searchbillCategorie === defaultBillCategorie.BAU}
                            onChange={() => setbillCategorie(defaultBillCategorie.BAU)}
                        />
                        <p>Bau</p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-billCategorie"
                            className="radio"
                            value="option4"
                            checked={
                                billCategorie === defaultBillCategorie.VERMIETUNG || props.searchbillCategorie === defaultBillCategorie.VERMIETUNG
                            }
                            onChange={() => setbillCategorie(defaultBillCategorie.VERMIETUNG)}
                        />
                        <p>Vermietung</p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-billCategorie"
                            className="radio"
                            value="option5"
                            checked={billCategorie === defaultBillCategorie.SONSTIGES || props.searchbillCategorie === defaultBillCategorie.SONSTIGES}
                            onChange={() => setbillCategorie(defaultBillCategorie.SONSTIGES)}
                        />
                        <p>Sonstiges</p>
                    </div>
                </div>
            )}
            {/* Filter Bill Types */}
            {props.changebillType && (
                <div className="flex flex-col gap-1 pt-4">
                    <h3 className="py-1 font-medium">Nach Typ filtern</h3>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-billType"
                            className="radio"
                            value="option1"
                            checked={billType === defaultBillType.NORMAL || props.searchbillType === defaultBillType.NORMAL}
                            onChange={() => setbillType(defaultBillType.NORMAL)}
                        />
                        <p>Rechnung (Normal)</p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-billType"
                            className="radio"
                            value="option2"
                            checked={billType === defaultBillType.RECURING || props.searchbillType === defaultBillType.RECURING}
                            onChange={() => setbillType(defaultBillType.RECURING)}
                        />
                        <p>Dauerrechnung</p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-billType"
                            className="radio"
                            value="option3"
                            checked={billType === defaultBillType.YEAR || props.searchbillType === defaultBillType.YEAR}
                            onChange={() => setbillType(defaultBillType.YEAR)}
                        />
                        <p>Jahresrechnung</p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-billType"
                            className="radio"
                            value="option4"
                            checked={billType === defaultBillType.ADVANCE || props.searchbillType === defaultBillType.ADVANCE}
                            onChange={() => setbillType(defaultBillType.ADVANCE)}
                        />
                        <p>Abschlagsrechnung</p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-billType"
                            className="radio"
                            value="option5"
                            checked={billType === defaultBillType.FINAL || props.searchbillType === defaultBillType.FINAL}
                            onChange={() => setbillType(defaultBillType.FINAL)}
                        />
                        <p>Schlussrechnung</p>
                    </div>
                </div>
            )}
            {/* Filter Status Offer */}
            {props.changeStatus && props.statusType === "offer" && (
                <div className="flex flex-col gap-1 pt-4">
                    <h3 className="py-1 font-medium">Nach Status filtern</h3>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-archived"
                            className="radio"
                            value="option1"
                            checked={status === defaultOfferStatusValues.DONE}
                            onChange={() => setstatus(defaultOfferStatusValues.DONE)}
                        />
                        <p>Angenommen</p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-archived"
                            className="radio"
                            value="option2"
                            checked={status === defaultOfferStatusValues.OPEN}
                            onChange={() => setstatus(defaultOfferStatusValues.OPEN)}
                        />
                        <p>Ausstehend</p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-archived"
                            className="radio"
                            value="option3"
                            checked={status === defaultOfferStatusValues.CANCELED}
                            onChange={() => setstatus(defaultOfferStatusValues.CANCELED)}
                        />
                        <p>Abgelehnt</p>
                    </div>
                </div>
            )}
            {/* Filter Status Payment Requirements */}
            {props.changeStatus && props.statusType === "payreq" && (
                <div className="flex flex-col gap-1 pt-4">
                    <h3 className="py-1 font-medium">Nach Status filtern</h3>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-bill-1"
                            className="radio"
                            value="option1"
                            checked={status === defaultPayreqStatusValues.DONE}
                            onChange={() => setstatus(defaultPayreqStatusValues.DONE)}
                        />
                        <p>Beglichen</p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-bill-1"
                            className="radio"
                            value="option2"
                            checked={status === defaultPayreqStatusValues.OPEN}
                            onChange={() => setstatus(defaultPayreqStatusValues.OPEN)}
                        />
                        <p>Ausstehend</p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-bill-1"
                            className="radio"
                            value="option3"
                            checked={status === defaultPayreqStatusValues.OVERDUE}
                            onChange={() => setstatus(defaultPayreqStatusValues.OVERDUE)}
                        />
                        <p>Überfällig</p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-bill-1"
                            className="radio"
                            value="option3"
                            checked={status === defaultPayreqStatusValues.CANCELED}
                            onChange={() => setstatus(defaultPayreqStatusValues.CANCELED)}
                        />
                        <p>Storniert</p>
                    </div>
                </div>
            )}
            {/* Filter Employee Position */}
            {props.changePosition && props.statusType === "employee" && (
                <div className="flex flex-col gap-1 pt-4">
                    <h3 className="py-1 font-medium">Bestimmte Position anzeigen</h3>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-position"
                            className="radio"
                            value="option1"
                            checked={position === undefined}
                            onChange={() => setposition(undefined)}
                        />
                        <p>Alle</p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-employee-2"
                            className="radio"
                            value="option2"
                            checked={position === defaultPositions.MA}
                            onChange={() => setposition(defaultPositions.MA)}
                        />
                        <p>Mitarbeiter</p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-employee-2"
                            className="radio"
                            value="option5"
                            checked={position === defaultPositions.BO1}
                            onChange={() => setposition(defaultPositions.BO1)}
                        />
                        <p>Backoffice 1</p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-employee-2"
                            className="radio"
                            value="option6"
                            checked={position === defaultPositions.ADMIN}
                            onChange={() => setposition(defaultPositions.ADMIN)}
                        />
                        <p>Admin</p>
                    </div>
                </div>
            )}
            {/* Filter Archived */}
            {props.changeArchived && (
                <div className="flex flex-col gap-1 pt-4">
                    <h3 className="py-1 font-medium">Archiv anzeigen</h3>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-offer-archive-1"
                            className="radio"
                            value="option1"
                            checked={archived === false}
                            onChange={() => setarchived(false)}
                        />
                        <p>
                            Archivierte{" "}
                            {props.statusType === "offer"
                                ? "Angebote"
                                : props.statusType === "bill"
                                ? "Rechnungen"
                                : props.statusType === "object"
                                ? "Objekte"
                                : props.statusType === "customer"
                                ? "Kunden"
                                : props.statusType === "major-order"
                                ? "Aufträge"
                                : "Mitarbeiter"}{" "}
                            nicht anzeigen
                        </p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-offer-archive-1"
                            className="radio"
                            value="option2"
                            checked={archived === undefined}
                            onChange={() => setarchived(undefined)}
                        />
                        <p>
                            Archivierte{" "}
                            {props.statusType === "offer"
                                ? "Angebote"
                                : props.statusType === "bill"
                                ? "Rechnungen"
                                : props.statusType === "object"
                                ? "Objekte"
                                : props.statusType === "customer"
                                ? "Kunden"
                                : props.statusType === "major-order"
                                ? "Aufträge"
                                : "Mitarbeiter"}{" "}
                            mit anzeigen
                        </p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-offer-archive-1"
                            className="radio"
                            value="option3"
                            checked={archived === true}
                            onChange={() => setarchived(true)}
                        />
                        <p>
                            Nur Archivierte{" "}
                            {props.statusType === "offer"
                                ? "Angebote"
                                : props.statusType === "bill"
                                ? "Rechnungen"
                                : props.statusType === "object"
                                ? "Objekte"
                                : props.statusType === "customer"
                                ? "Kunden"
                                : props.statusType === "major-order"
                                ? "Aufträge"
                                : "Mitarbeiter"}{" "}
                            anzeigen
                        </p>
                    </div>
                </div>
            )}
            {/* Filter Deleted */}
            {props.changeDeleted && (
                <div className="flex flex-col gap-1 pt-4">
                    <h3 className="py-1 font-medium">Gelöscht anzeigen</h3>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-offer-delete-1"
                            className="radio"
                            value="option1"
                            checked={deleted === false}
                            onChange={() => setdeleted(false)}
                        />
                        <p>
                            Gelöschte {props.statusType === "object" ? "Objekte" : props.statusType === "customer" ? "Kunden" : "404"} nicht anzeigen
                        </p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-offer-delete-1"
                            className="radio"
                            value="option2"
                            checked={deleted === true}
                            onChange={() => setdeleted(true)}
                        />
                        <p>Nur Gelöschte {props.statusType === "object" ? "Objekte" : props.statusType === "customer" ? "Kunden" : "404"} anzeigen</p>
                    </div>
                </div>
            )}
            {/* Filter Canceled */}
            {props.changeCanceled && (
                <div className="flex flex-col gap-1 pt-4">
                    <h3 className="py-1 font-medium">Storniert anzeigen</h3>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-offer-canceled-1"
                            className="radio"
                            value="option1"
                            checked={canceled === false || canceled === undefined}
                            onChange={() => setcanceled(false)}
                        />
                        <p>Storniert Nicht Anzeigen</p>
                    </div>
                    <div className="flex flex-row gap-6 pl-2">
                        <input
                            type="radio"
                            name="radio-group-offer-canceled-1"
                            className="radio"
                            value="option2"
                            checked={canceled === true}
                            onChange={() => setcanceled(true)}
                        />
                        <p>Storniert Anzeigen</p>
                    </div>
                </div>
            )}
            {/* Filter Dates */}
            {props.changeDateSince && props.changeDateTo && (
                <div className="flex flex-col gap-1 pt-6">
                    <h3 className="py-1 font-medium">Nach Zeitraum filtern</h3>
                    <BaseInputField value={dateSince} onChange={setdateSince} label={"von"} type={"date"} />
                    <BaseInputField value={dateTo} onChange={setdateTo} label={"bis"} type={"date"} />
                </div>
            )}
            {/* Use & Reset */}
            <div className="flex flex-row items-center justify-between mt-6">
                <p
                    className="underline text-sm cursor-pointer"
                    onClick={() => {
                        props.removeFilter()
                        removeInternFilterValues()
                    }}>
                    Zurücksetzen
                </p>
                <button className="btn btn-primary btn-outline" onClick={useFilter}>
                    Anwenden
                </button>
            </div>
        </motion.div>
    )
}
